import styled from "styled-components";
import { SyncOutlined } from "@ant-design/icons";
import { Space, Button as AntButton } from "antd";
import { IMG_TOP_BG_1, IMG_BADGE } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow-y: auto;
`;

export const RefreshIcon = styled(SyncOutlined)`
	font-size: 24px;
	color: #fff;
`;

export const TableWrapper = styled.div`
	margin-top: 365px;
	padding-bottom: 20px;
	.ant-table-wrapper {
		margin: 16px 16px 0 16px;
	}

	@media screen and (max-width: 400px) {
		margin-top: 340px;
	}
	@media screen and (max-width: 365px) {
		.ant-table-cell {
			font-size: 12px !important;
		}
	}
	@media screen and (max-width: 330px) {
		.ant-table-cell {
			padding: 8px 1px !important;
		}
	}

	/* background-color: white;
  border-radius: 12px; */
`;

export const Bottom = styled(Space)`
	padding-top: 305px;
	padding-bottom: 16px;
	z-index: 99;
	background-color: ${(props) => props.theme.backgroundColor};
	position: fixed;
	width: 100%;
	max-width: 480px;
	gap: 16px !important;
	justify-content: center;

	.ant-space-item {
		flex: 1;

		:nth-child(1) {
			text-align: right;
			padding-inline-start: 16px;
		}

		:nth-child(2) {
			text-align: left;
			padding-inline-end: 16px;
		}
	}

	.ant-btn {
		width: 100%;
		background-color: #71207c !important;
	}

	@media screen and (max-width: 400px) {
		padding-top: 285px;
	}
`;

export const Title = styled.div`
	padding: 10px 0;
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
	color: ${(props) => props.theme.textColor};
	text-align: center;
`;

export const TopBgImage = styled.img.attrs({
	alt: "bg-img",
	src: IMG_TOP_BG_1,
})`
	position: fixed;
	top: 0;
	width: 100%;
	max-width: 480px;
	/* height: 250px; */
	height: 500px;
	/* z-index: 500; */

	/* @media screen and (min-width: 400px) {
    height: 300px;
  } */
`;

export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const WheelContainer = styled.div`
	position: fixed;
	width: 100%;
	max-width: 480px;
	z-index: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 10px;
	/* transform: rotate(20deg) */
	> div {
		width: 245px;
		height: 245px;
		transform: rotate(-48deg);
	}

	img:not(#badge-img):not(#center) {
		height: 40px;
		width: 30px;
		transform: rotate(47deg) translate(-10%, 30%);
	}
	@media screen and (max-width: 400px) {
		> div {
			width: 230px;
			height: 230px;
		}
	}
	@media screen and (max-width: 325px) {
		margin-top: 45px;

		> div {
			width: 200px;
			height: 200px;
		}

		img:not(#badge-img):not(#center) {
			height: 30px;
			width: 20px;
			transform: rotate(47deg) translate(-10%, 30%);
		}
	}
`;

// img:not(#badge-img) {
//   top: calc(50% - 51px);
//   left: calc(50% + 38px);
//   width: 100px !important;

//   transform: rotate(-37deg) translate(-50%, -50%); /* W3C */
//   -webkit-transform: rotate(-37deg) translate(-50%, -50%); /* Safari & Chrome */
//   -moz-transform: rotate(-37deg) translate(-50%, -50%); /* Firefox */
//   -ms-transform: rotate(-37deg) translate(-50%, -50%); /* Internet Explorer */
//   -o-transform: rotate(-37deg) translate(-50%, -50%); /* Opera */
// }

// @media screen and (max-width: 400px) {
//   > div {
//     width: 230px;
//     height: 230px;
//   }
// }

// @media screen and (max-width: 325px) {
//   margin-top: 45px;

//   > div {
//     width: 200px;
//     height: 200px;
//   }

//   img:not(#badge-img) {
//     top: calc(50% - 48px);
//     left: calc(50% + 35px);
//     width: 90px !important;

//     transform: rotate(-37deg) translate(-50%, -50%); /* W3C */
//     -webkit-transform: rotate(-37deg) translate(-50%, -50%); /* Safari & Chrome */
//     -moz-transform: rotate(-37deg) translate(-50%, -50%); /* Firefox */
//     -ms-transform: rotate(-37deg) translate(-50%, -50%); /* Internet Explorer */
//     -o-transform: rotate(-37deg) translate(-50%, -50%); /* Opera */
//   }
// }

export const OuterBadge = styled.img.attrs({
	alt: "badge",
	id: "badge-img",
	src: IMG_BADGE,
})`
	position: absolute;
	width: 270px;
	height: 270px;
	border-radius: 50%;
	cursor: pointer;
	/* transform: rotate(0deg); */

	@media screen and (max-width: 400px) {
		width: 255px;
		height: 255px;
	}

	@media screen and (max-width: 325px) {
		width: 220px;
		height: 220px;
	}
`;

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	padding-top: 80px;

	.ant-btn {
		min-width: 80px;
		margin-top: 120px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: ${(props) => props.theme.textColor};
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: calc(100vh - 70px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const WinnerItem = styled.div`
	/* padding: 6px; */
	display: flex;
	justify-content: space-between;
	border-top: 1px solid ${(props) => props.theme.dark4};
	border-bottom: 1px solid ${(props) => props.theme.dark4};
`;

export const LeftSection = styled.div`
	display: flex;
`;

export const NumberWrapper = styled.div`
	border-right: 1px solid ${(props) => props.theme.dark4};
`;

export const Number = styled.div`
	margin-top: 7px;
	border-right: 1px solid ${(props) => props.theme.dark4};
	padding: 12px;
	width: 20px;
	color: ${(props) => props.theme.textColor};
`;

export const PhNameWrapper = styled.div`
	padding: 12px;
`;

export const NameWrapper = styled.div`
	color: ${(props) => props.theme.dark1};
	font-size: 14px;
	font-weight: 600;
	line-height: 21px;
	@media (max-height: 700px) {
		font-size: 12px;
	}
	@media (max-height: 640px) {
		font-size: 8px;
	}
`;

export const PhoneWrapper = styled.div`
	color: ${(props) => props.theme.dark3};
	font-size: 12px;
	font-weight: 400;
	line-height: 18px;
`;

export const AmountWrapper = styled.div`
	padding: 12px;
	color: ${(props) => props.theme.textColor};
	font-size: 14px;
	font-weight: 600;
	line-height: 21px;
`;

export const ButtonWrapper = styled.div`
	background: ${(props) => props.theme.golden};
	height: 52px;
	border-radius: 0px 0px 12px 12px;
	display: flex;
	justify-content: space-between;
	padding: 5px 0;
	margin-top: 400px;
	position: absolute;
	bottom: 0;
	width: 100%;
	@media (max-height: 700px) {
		height: 45px;
		padding: 3px 0;
	}
	@media (max-height: 640px) {
		height: 35px;
		padding: 2px 0;
	}
`;

export const ButtonDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50%;
	cursor: pointer;
	font-size: 16px;
	font-weight: 600;
	color: ${(props) => props.theme.textColor};
	@media (max-height: 700px) {
		font-size: 12px;
	}
	@media (max-height: 640px) {
		font-size: 12px;
	}
`;
export const TableContainer = styled.div`
	margin-top: 8px;
	background: white;
	height: 438px;
	width: 358px;
	z-index: 99;
	border-radius: 12px;
	position: relative;
	@media (max-height: 800px) {
		height: 330px;
	}
	@media (max-height: 700px) {
		height: 290px;
	}
	@media (max-height: 640px) {
		height: 250px;
	}

	@media (max-width: 375px) {
		width: 330px;
	}
	@media (max-width: 330px) {
		width: 290px;
	}
`;

export const WinnersContainer = styled.div`
	max-height: 332px;
	overflow: auto;
	@media (max-height: 800px) {
		max-height: 215px;
	}
	@media (max-height: 640px) {
		max-height: 200px;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 1000;
	margin-top: 240px;
	@media screen and (min-height: 800px) {
		margin-top: 230px;
	}
`;

export const Button = styled(AntButton)`
	border: none;
	font-weight: 600;
	background: ${(props) => props.theme.white} !important;
	width: 165px;
	height: 47px;
	.ant-btn {
		animation: none !important;
	}
	color: ${(props) => props.theme.textColor};
	font-size: 18px;
	font-weight: 600;
	line-height: 26.68px;
	/* margin-top: 10px; */
	/* @media screen and (min-height: 800px) {
		margin-top: 0px;
	} */
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	border-radius: 50px !important;
`;

export const OkButton = styled(AntButton)`
	border: none;
	font-weight: 600;
	border-radius: 50px;
	width: 165px;
	height: 47px;
	font-size: 18px;
	font-weight: 600;
	line-height: 26.68px;
`;

export const CenterIcon = styled.img.attrs((props) => ({
	id: props.id,
	src: props.src,
}))`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1000;
	width: 50px;
	height: 50px;

	@media screen and (max-width: 325px) {
		width: 40px;
		height: 40px;
	}
`;
